/**
 * @generated SignedSource<<058c98254728c8eaf7ee410aec84874e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImpactfulProposalsProposalFragment$data = {
  readonly number: number;
  readonly title: string;
  readonly totalValue: any;
  readonly " $fragmentType": "ImpactfulProposalsProposalFragment";
};
export type ImpactfulProposalsProposalFragment$key = {
  readonly " $data"?: ImpactfulProposalsProposalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImpactfulProposalsProposalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ImpactfulProposalsProposalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalValue",
      "storageKey": null
    }
  ],
  "type": "Proposal",
  "abstractKey": null
};

(node as any).hash = "19ad200215347b1b9295e7374350187a";

export default node;
